var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { hideMenuProvider } from '../../utilities/picker.tools';
import { currentDateKey, keyToDate } from '../date/date-picker-calculations';
import styles from '../sds-date-picker.lit.scss';
import '../shared/calendar/sds-calendar.lit';
import { displayWeekDate, keyToWeek, localDateToLocalWeek, monthWithMostDaysInWeek, normalizeLocalWeek, weekToDays, weekToKey, } from './week-picker-calculations';
import { translate } from '../../utilities/translate';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-week-picker` is a web component designed for selecting a specific week within a given year.
 * It allows users to easily navigate through weeks, making it suitable for applications that require
 * precise date selections, such as scheduling, planning, or event management.
 *
 * The component features customizable attributes, including options for placeholders, locale settings,
 * the currently selected week, hints, and error handling.
 *
 * ### Attributes
 * - `placeholder`: The placeholder text for the input field, providing a hint to users when no week is selected.
 *   Defaults to `'sds.week_picker.placeholder'`.
 * - `locale`: The locale for the week picker, determining the language and regional formatting.
 *   Defaults to `'en'`.
 * - `current-day`: The current date represented in `{year}/{week}` format, helping users identify their
 *   current context within the picker.
 * - `hint`: A hint to provide context for the week picker, enhancing user understanding.
 * - `disabled`: A boolean indicating if the week picker is disabled, preventing user interaction.
 *   Defaults to `false`.
 * - `invalid`: A boolean indicating if the week picker is invalid, typically used for validation feedback.
 *   Defaults to `false`.
 * - `error-message`: The error message displayed when the week picker is invalid, informing users about
 *   validation issues.
 * - `selected-week`: Represents the selected week in `{year}/{week}` format, allowing users to know
 *   which week is currently selected or undefined if none is selected.
 *
 * @tag sds-week-picker
 */
let SdsWeekPicker = (() => {
    var _SdsWeekPicker_placeholder_accessor_storage, _SdsWeekPicker_locale_accessor_storage, _SdsWeekPicker_currentDay_accessor_storage, _SdsWeekPicker_hint_accessor_storage, _SdsWeekPicker_disabled_accessor_storage, _SdsWeekPicker_invalid_accessor_storage, _SdsWeekPicker_errorMessage_accessor_storage, _SdsWeekPicker_selectedWeek_accessor_storage, _SdsWeekPicker__contextMenu_accessor_storage, _SdsWeekPicker__inputDate_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-week-picker')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _locale_decorators;
    let _locale_initializers = [];
    let _locale_extraInitializers = [];
    let _currentDay_decorators;
    let _currentDay_initializers = [];
    let _currentDay_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _selectedWeek_decorators;
    let _selectedWeek_initializers = [];
    let _selectedWeek_extraInitializers = [];
    let __contextMenu_decorators;
    let __contextMenu_initializers = [];
    let __contextMenu_extraInitializers = [];
    let __inputDate_decorators;
    let __inputDate_initializers = [];
    let __inputDate_extraInitializers = [];
    var SdsWeekPicker = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsWeekPicker_placeholder_accessor_storage.set(this, __runInitializers(this, _placeholder_initializers, 'sds.week_picker.placeholder'));
            _SdsWeekPicker_locale_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _locale_initializers, 'en')));
            _SdsWeekPicker_currentDay_accessor_storage.set(this, (__runInitializers(this, _locale_extraInitializers), __runInitializers(this, _currentDay_initializers, currentDateKey())));
            _SdsWeekPicker_hint_accessor_storage.set(this, (__runInitializers(this, _currentDay_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsWeekPicker_disabled_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsWeekPicker_invalid_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsWeekPicker_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsWeekPicker_selectedWeek_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _selectedWeek_initializers, void 0)));
            _SdsWeekPicker__contextMenu_accessor_storage.set(this, (__runInitializers(this, _selectedWeek_extraInitializers), __runInitializers(this, __contextMenu_initializers, void 0)));
            _SdsWeekPicker__inputDate_accessor_storage.set(this, (__runInitializers(this, __contextMenu_extraInitializers), __runInitializers(this, __inputDate_initializers, void 0)));
            this._sdsCalendar = __runInitializers(this, __inputDate_extraInitializers);
            this.hideMenu = hideMenuProvider(this);
            this.handleCleared = () => {
                var _a;
                this._inputDate.focused = Boolean((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened);
                this.updateSelectedWeek();
            };
            this.handleDatePicked = (event) => {
                this.updateSelectedWeek(localDateToLocalWeek(event.detail.date));
            };
            this.handleWeekPicked = (event) => {
                this.updateSelectedWeek(event.detail.week);
            };
            this.handleMonthSelect = (event) => {
                var _a, _b;
                const [year, month] = event.detail.month;
                (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setMonthStateMapper(([keyYear, keyMonth]) => keyYear === year && keyMonth === month ? 'selected' : 'none');
                (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.setYearStateMapper(keyYear => (keyYear === year ? 'selected' : 'none'));
            };
            this.handleYearSelect = (event) => {
                var _a;
                (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setYearStateMapper(keyYear => keyYear === event.detail.year ? 'selected' : 'none');
            };
            this.showContextMenu = () => {
                var _a, _b;
                if (!((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened)) {
                    this.resetPage();
                    this._inputDate.focused = true;
                    const trigger = this._inputDate.getInput();
                    (_b = this._contextMenu) === null || _b === void 0 ? void 0 : _b.show(trigger);
                    this.setMappers();
                }
            };
        }
        /**
         * Sets the placeholder text for the week picker input, providing a hint to users when no week is selected.
         * This attribute helps guide users to understand the expected input or purpose of the week selection.
         *
         * This placeholder text enhances accessibility and user experience by indicating
         * what the user is expected to select.
         *
         * @attr {string} placeholder - Placeholder text for the week picker input.
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsWeekPicker_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsWeekPicker_placeholder_accessor_storage, value, "f"); }
        /**
         * Sets the locale for the week picker, determining the language and regional formatting used in the component.
         * This allows users to interact with the week picker in their preferred language or regional setting.
         *
         * By default, this attribute is set to `'en'`, but it can be customized to support multiple languages.
         *
         * @attr {string} locale - Locale setting for the week picker.
         */
        get locale() { return __classPrivateFieldGet(this, _SdsWeekPicker_locale_accessor_storage, "f"); }
        set locale(value) { __classPrivateFieldSet(this, _SdsWeekPicker_locale_accessor_storage, value, "f"); }
        /**
         * Represents the current day in `{year}/{week}` format, helping users identify their current context within the week picker.
         * This value can be used for initializing the picker or for informational purposes.
         *
         * By default, this attribute is set to the current date using `currentDateKey()`.
         *
         * @attr {string} current-day - The current day formatted as `{year}/{week}`.
         */
        get currentDay() { return __classPrivateFieldGet(this, _SdsWeekPicker_currentDay_accessor_storage, "f"); }
        set currentDay(value) { __classPrivateFieldSet(this, _SdsWeekPicker_currentDay_accessor_storage, value, "f"); }
        /**
         * Sets a hint for the week picker, providing additional context or guidance to users on how to use the component.
         * This attribute can be useful for enhancing user experience by clarifying the purpose of the week selection.
         *
         * @attr {string} hint - Hint text for the week picker.
         */
        get hint() { return __classPrivateFieldGet(this, _SdsWeekPicker_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsWeekPicker_hint_accessor_storage, value, "f"); }
        /**
         * Indicates whether the week picker is disabled, preventing user interaction when set to `true`.
         * This is useful in scenarios where you want to control user input based on application logic or state.
         *
         * By default, this attribute is set to `false`, allowing interaction.
         *
         * @attr {boolean} disabled - If `true`, the week picker is disabled.
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsWeekPicker_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsWeekPicker_disabled_accessor_storage, value, "f"); }
        /**
         * Indicates whether the week picker is in an invalid state, which is typically used for validation feedback.
         * This attribute allows developers to provide visual cues to users when their selection is not valid.
         *
         * By default, this attribute is set to `false`, indicating a valid state.
         *
         * @attr {boolean} invalid - If `true`, the week picker is invalid.
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsWeekPicker_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsWeekPicker_invalid_accessor_storage, value, "f"); }
        /**
         * Sets the error message to display when the week picker is invalid, informing users about validation issues.
         * This message helps guide users in correcting their input when a selection does not meet validation criteria.
         *
         * By default, this attribute is an empty string, meaning no error message is displayed.
         *
         * @attr {string} error-message - Error message for invalid week picker input.
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsWeekPicker_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsWeekPicker_errorMessage_accessor_storage, value, "f"); }
        /**
         * Represents the selected week in `{year}/{week}` format, indicating which week is currently selected.
         * This attribute allows users to know their current selection or indicates `undefined` if none is selected.
         *
         * @attr {string} selected-week - Selected week in `{year}/{week}` format.
         */
        get selectedWeek() { return __classPrivateFieldGet(this, _SdsWeekPicker_selectedWeek_accessor_storage, "f"); }
        set selectedWeek(value) { __classPrivateFieldSet(this, _SdsWeekPicker_selectedWeek_accessor_storage, value, "f"); }
        get _contextMenu() { return __classPrivateFieldGet(this, _SdsWeekPicker__contextMenu_accessor_storage, "f"); }
        set _contextMenu(value) { __classPrivateFieldSet(this, _SdsWeekPicker__contextMenu_accessor_storage, value, "f"); }
        get _inputDate() { return __classPrivateFieldGet(this, _SdsWeekPicker__inputDate_accessor_storage, "f"); }
        set _inputDate(value) { __classPrivateFieldSet(this, _SdsWeekPicker__inputDate_accessor_storage, value, "f"); }
        render() {
            return html `
            <sds-input-date
                id="input-date"
                placeholder="${translate(this.placeholder)}"
                readonly
                ?disabled="${this.disabled}"
                hint="${this.hint}"
                error-message="${this.errorMessage}"
                ?invalid="${this.invalid}"
                @click="${this.showContextMenu}"
                @sds.input-date.cleared="${this.handleCleared}"
            ></sds-input-date>
            <sds-context-menu>
                <sds-calendar
                    currentDay="${this.currentDay}"
                    @sds.calendar.select="${this.handleDatePicked}"
                    @sds.calendar.week.select="${this.handleWeekPicked}"
                    @sds.calendar.month.select="${this.handleMonthSelect}"
                    @sds.calendar.year.select="${this.handleYearSelect}"
                    week-numbers
                    per-week-hover
                    tabindex="0"
                >
                </sds-calendar>
            </sds-context-menu>
        `;
        }
        connectedCallback() {
            super.connectedCallback();
            document.addEventListener('mouseup', this.hideMenu);
            this.addEventListener('keydown', (event) => {
                var _a, _b;
                if (event.key === 'Escape') {
                    this.hideContextMenu();
                }
                else if (event.key === 'ArrowLeft') {
                    (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.updatePageIndex(0, -1);
                }
                else if (event.key === 'ArrowRight') {
                    (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.updatePageIndex(0, 1);
                }
                else if (event.key === 'ArrowDown') {
                    if (this.selectedWeek) {
                        const [year, week] = this.selectedWeek;
                        this.updateSelectedWeek(normalizeLocalWeek(year, week + 1));
                    }
                }
                else if (event.key === 'ArrowUp') {
                    if (this.selectedWeek) {
                        const [year, week] = this.selectedWeek;
                        this.updateSelectedWeek(normalizeLocalWeek(year, week - 1));
                    }
                }
            });
        }
        disconnectedCallback() {
            document.removeEventListener('mouseup', this.hideMenu);
            this.hideContextMenu();
            super.disconnectedCallback();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        willUpdate(_changedProperties) {
            if (_changedProperties.has('selectedWeek')) {
                this.setMappers();
                this.hideContextMenu();
            }
        }
        updated(_changedProperties) {
            if (_changedProperties.has('selectedWeek')) {
                if (this.selectedWeek) {
                    this.updateInput(this.selectedWeek);
                }
                else {
                    this.updateInput();
                }
            }
        }
        async firstUpdated() {
            this.initCmContentContainer();
            await this.updateComplete;
            this.updatePageIndex();
        }
        initCmContentContainer() {
            var _a;
            const sdsCalendar = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-calendar');
            if (sdsCalendar) {
                this._sdsCalendar = sdsCalendar;
            }
        }
        resetPage() {
            var _a;
            (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.navigateTo('SelectDate');
            this.updatePageIndex();
        }
        updatePageIndex() {
            var _a, _b;
            if (this.selectedWeek) {
                const month = monthWithMostDaysInWeek(weekToDays(this.selectedWeek));
                (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setPageIndex(this.selectedWeek[0], month);
            }
            else {
                const [year, month] = keyToDate(this.currentDay);
                (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.setPageIndex(year, month);
            }
        }
        hideContextMenu() {
            var _a;
            if ((_a = this._contextMenu) === null || _a === void 0 ? void 0 : _a.opened) {
                this._contextMenu.hide();
            }
        }
        dispatchChange(week) {
            this.dispatchEvent(new CustomEvent(SdsWeekPicker.CHANGE_EVENT, {
                detail: {
                    selectedWeek: week ? weekToKey(...week) : undefined,
                },
            }));
        }
        updateSelectedWeek(week) {
            this.selectedWeek = week;
            this.updatePageIndex();
            this.dispatchChange(week);
            this.setMappers();
        }
        setMappers() {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (this.selectedWeek) {
                const [year, week] = this.selectedWeek;
                const days = weekToDays(this.selectedWeek);
                const month = monthWithMostDaysInWeek(days);
                (_a = this._sdsCalendar) === null || _a === void 0 ? void 0 : _a.setDateStateMapper(([keyYear, keyMonth, keyDay]) => days.find(([year, month, day]) => keyYear === year && keyMonth === month && keyDay === day)
                    ? 'sub-selected'
                    : 'none');
                (_b = this._sdsCalendar) === null || _b === void 0 ? void 0 : _b.setWeekStateMapper(([keyYear, keyWeek]) => keyYear === year && keyWeek === week ? 'selected' : 'none');
                (_c = this._sdsCalendar) === null || _c === void 0 ? void 0 : _c.setMonthStateMapper(([keyYear, keyMonth]) => keyYear === year && keyMonth === month ? 'selected' : 'none');
                (_d = this._sdsCalendar) === null || _d === void 0 ? void 0 : _d.setYearStateMapper(keyYear => keyYear === year ? 'selected' : 'none');
            }
            else {
                (_e = this._sdsCalendar) === null || _e === void 0 ? void 0 : _e.setDateStateMapper(() => 'none');
                (_f = this._sdsCalendar) === null || _f === void 0 ? void 0 : _f.setWeekStateMapper(() => 'none');
                (_g = this._sdsCalendar) === null || _g === void 0 ? void 0 : _g.setMonthStateMapper(() => 'none');
                (_h = this._sdsCalendar) === null || _h === void 0 ? void 0 : _h.setYearStateMapper(() => 'none');
            }
        }
        updateInput(date) {
            this._inputDate.value = date ? displayWeekDate(date, this.locale) : '';
        }
    };
    _SdsWeekPicker_placeholder_accessor_storage = new WeakMap();
    _SdsWeekPicker_locale_accessor_storage = new WeakMap();
    _SdsWeekPicker_currentDay_accessor_storage = new WeakMap();
    _SdsWeekPicker_hint_accessor_storage = new WeakMap();
    _SdsWeekPicker_disabled_accessor_storage = new WeakMap();
    _SdsWeekPicker_invalid_accessor_storage = new WeakMap();
    _SdsWeekPicker_errorMessage_accessor_storage = new WeakMap();
    _SdsWeekPicker_selectedWeek_accessor_storage = new WeakMap();
    _SdsWeekPicker__contextMenu_accessor_storage = new WeakMap();
    _SdsWeekPicker__inputDate_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsWeekPicker");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _placeholder_decorators = [property({ type: String })];
        _locale_decorators = [property()];
        _currentDay_decorators = [property({ attribute: 'current-date' })];
        _hint_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _selectedWeek_decorators = [property({
                type: String,
                converter: keyToWeek,
                attribute: 'selected-week',
            })];
        __contextMenu_decorators = [query('sds-context-menu')];
        __inputDate_decorators = [query('#input-date')];
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _locale_decorators, { kind: "accessor", name: "locale", static: false, private: false, access: { has: obj => "locale" in obj, get: obj => obj.locale, set: (obj, value) => { obj.locale = value; } }, metadata: _metadata }, _locale_initializers, _locale_extraInitializers);
        __esDecorate(_classThis, null, _currentDay_decorators, { kind: "accessor", name: "currentDay", static: false, private: false, access: { has: obj => "currentDay" in obj, get: obj => obj.currentDay, set: (obj, value) => { obj.currentDay = value; } }, metadata: _metadata }, _currentDay_initializers, _currentDay_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _selectedWeek_decorators, { kind: "accessor", name: "selectedWeek", static: false, private: false, access: { has: obj => "selectedWeek" in obj, get: obj => obj.selectedWeek, set: (obj, value) => { obj.selectedWeek = value; } }, metadata: _metadata }, _selectedWeek_initializers, _selectedWeek_extraInitializers);
        __esDecorate(_classThis, null, __contextMenu_decorators, { kind: "accessor", name: "_contextMenu", static: false, private: false, access: { has: obj => "_contextMenu" in obj, get: obj => obj._contextMenu, set: (obj, value) => { obj._contextMenu = value; } }, metadata: _metadata }, __contextMenu_initializers, __contextMenu_extraInitializers);
        __esDecorate(_classThis, null, __inputDate_decorators, { kind: "accessor", name: "_inputDate", static: false, private: false, access: { has: obj => "_inputDate" in obj, get: obj => obj._inputDate, set: (obj, value) => { obj._inputDate = value; } }, metadata: _metadata }, __inputDate_initializers, __inputDate_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsWeekPicker = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.CHANGE_EVENT = 'sds.week-picker.changed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsWeekPicker = _classThis;
})();
export { SdsWeekPicker };
